import { useNavigate } from "react-router-dom";

import { useAuth } from "../contexts/AuthContext";
import Sidebar from "./Sidebar";
import StoreSelector from "./StoreSelector";

export default function Layout({ children }: { children: React.ReactNode }) {
  const { setToken } = useAuth();
  const navigate = useNavigate();

  function logout() {
    setToken(null);
    navigate("/login");
  }

  return (
    <div className="layout">
      <Sidebar />
      <div className="layout__content">
        <header className="topbar">
          <StoreSelector />
          <button type="button" className="topbar__logout" onClick={logout}>
            Wyloguj
          </button>
        </header>
        <main className="layout__main">{children}</main>
      </div>
    </div>
  );
}
